export const essence = {
  essence: {
    bannerAlert: {
      readonly: 'Inputs are ReadOnly while the NMOS service is enabled. ',
      viewServices: 'View Services.',
    },
    states: {
      failed: 'FAILED',
      running: 'ACTIVE',
      stopped: 'INACTIVE',
    },
    noContent: {
      title: 'No Inputs Configured',
      subText: 'Add an input to start your journey',
      btnText: 'Add Input',
    },
    mediaTypes: {
      video: 'Video',
      audio: 'Audio',
      data: 'ANC Data',
    },
    notifications: {
      changeErrorMsg: 'Input could not be updated',
      changeSuccessMsg: 'Input updated',
      deleteErrorMsg_plural: '{{count}} inputs could not be deleted',
      deleteErrorMsg: '{{count}} input could not be deleted',
      saveErrorMsg: 'Input could not be created',
      saveSuccessMsg: 'Input created',
      startErrorMsg_plural: '{{count}} inputs could not be started',
      startErrorMsg: '{{count}} input could not be started',
      stopErrorMsg_plural: '{{count}} inputs could not be stopped',
      stopErrorMsg: '{{count}} input could not be stopped',
    },
    sections: {
      essence: 'Essence',
      settings: 'Settings',
    },
    settings: {
      addEssence: 'Add Input',
      address: 'Address',
      ancData: 'ANC Data',
      autoStart: 'Auto-Start',
      inputChannel: 'Input',
      inputFormat: 'Video Format',
      numOfChannels: 'Number of Channels',
      numOfChannelsExplain: '1 - 16',
      packetTime: 'Packet Time',
      payload: 'Payload',
      port: 'Port',
      portExplain: '1 - 65535',
      rtpPayload: 'RTP Payload',
      rtpPayloadExplain: '0 - 127',
      sourceAddress: 'Source Address',
      type: 'Media Type',
      unnamedEssence: '(None)',
      modal: {
        delete: {
          title: 'Delete this input?',
          title_plural: 'Delete {{count}} inputs?',
        },
      },
    },
    statistics: {
      st2110: 'STATISTICS - SMPTE ST 2110',
      streamSync: 'Stream Sync',
      rxPackets: 'RX Packets',
      rxDiscardedPackets: 'RX Discarded Packets',
      rxLostPackets: 'RX Lost Packets',
      videoFormatDetectionState: 'Video Format Detection',
      detectedVideoFormat: 'Detected Video Format',
    },
  },
};
